import Modal from 'react-bootstrap/Modal';
import { HotTable } from '@handsontable/react';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import { Form, ButtonGroup } from 'react-bootstrap';

import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

import CheckIcon from '@mui/icons-material/Check';

import { Autocomplete, Button, Checkbox, FormControl, MenuItem, Select, styled, TextField, ToggleButtonGroup, toggleButtonGroupClasses, ToggleButton, ButtonBase } from '@mui/material';
import { SnackbarContext } from '../../../App';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { darkTheme } from '../../../utils/funtions';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

const reportTypes = [
  {
    name: 'Activity Statement Reports',
    abbr: 'ActSt',
  },
  {
    name: 'Client Account Summary',
    abbr: 'AccSt',
  },

];

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    display: 'flex',
    flex: 1,
    width: '100%',
    margin: '0.5vw',
    fontSize: '0.7vw',
    border: 0,
    borderRadius: theme.shape.borderRadius,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
      {
        marginLeft: -1,

        borderLeft: '1px solid transparent',
      },
}));

export default ({ show, onHide, onRefresh, clientList, docTypeList, filterDataHandler }) => {
  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage } = useContext(SnackbarContext);

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const navigate = useNavigate();
  const auth = useAuth();

  const [
    isSubmitting,
    setIsSubmitting,
  ] = useState(false);

  const [
    dateType,
    setDateType,
  ] = useState('range');

  const [
    fromDate,
    setFromDate,
  ] = useState(`${currentYear - 1}-07-01`);
  const [
    toDate,
    setToDate,
  ] = useState(`${currentYear}-06-30`);
  const [
    financialYearValue,
    setFinancialYearValue,
  ] = useState(currentYear);

  const [
    selectedClients,
    setSelectedClients,
  ] = useState([]);

  const [
    selectedDocTypes,
    setSelectedDocTypes,
  ] = useState([]);

  const [
    clients,
    setClients,
  ] = useState(clientList);

  const [
    docTypes,
    setDocTypes,
  ] = useState(docTypeList);

  const [
    selectedTypes,
    setSelectedTypes,
  ] = useState([
    'ActSt',
    'AccSt',
  ]);

  const { setSessionExpired } = useContext(SnackbarContext);

  const [
    period,
    setPeriod,
  ] = useState('all');

  const handlePeriodChange = (event) => {
    setPeriod(event.target.value);
  };

  function onClose() {
    onHide();
  }

  const handleClientSelect = (e, value) => {
    setSelectedClients(value);
  };

  const handleDocTypeSelect = (e, value) => {
    setSelectedDocTypes(value);
  };

  useEffect(() => {
    setClients(clientList);
  }, [clientList]);

  useEffect(() => {
    setDocTypes(docTypeList);
  }, [docTypeList]);

  function typeAddedDeleted(type) {
    let newTypesList = [...selectedTypes];
    if (newTypesList.includes(type)) {
      newTypesList = newTypesList.filter(item => item != type);
    } else {
      newTypesList.push(type);
    }
    setSelectedTypes(newTypesList);
  }

  const updatePeriod = (dates) => {
    const [
      start,
      end,
    ] = dates;
    setFromDate(dayjs(start).format('YYYY-MM-DD'));
    setToDate(dayjs(end).format('YYYY-MM-DD'));
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      dialogClassName="modal-50w"
      aria-labelledby="example-custom-modal-styling-title"
    >

      <Modal.Body style={{ color: 'rgb(0, 0, 0, 0.9)', padding: '1vw 2vw' }}>
        <h4 style={{ textAlign: 'center', fontSize: '1.3vw', margin: '1vw', fontWeight: '500' }}>Filter Documents</h4>
        <p style={{ margin: 0, marginBottom: '1vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.7)', textAlign: 'center' }}>Show only documents based on critetia</p>

        <Form style={{ display: 'flex', flexDirection: 'column', textAlign: 'left', paddingTop: '1vw' }}>
          <div style={{ marginBottom: '1vw', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
              <p style={{ fontSize: '0.85vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)' }}>Period</p>
            </div>

            <FormControl style={{ width: '100%' }}>
              <Select
                value={period}
                onChange={handlePeriodChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="week">Last 7 days</MenuItem>
                <MenuItem value="month">Last 1 month</MenuItem>
                <MenuItem value="quarter">Last 4 months</MenuItem>
                <MenuItem value="fy">Last 1 year</MenuItem>
              </Select>
            </FormControl>

          </div>

          <Form.Group className="mb-ClientName" controlId="exampleForm.ClientName" style={{ margin: '1vw 0' }}>
            {/* title */}
            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
              {/* <Form.Label style={{ fontSize: '1.3vw', display: 'flex', fontWeight: '600', marginBottom:'1.5vw' }}>Select Client</Form.Label> */}
              {/* <Form.Label style={{ fontSize: '1vw', fontWeight: '600', marginBottom:'1vw', marginLeft: '0.2vw' }}>Select Client</Form.Label> */}
              <p style={{ fontSize: '0.85vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)' }}>Clients</p>
            </div>

            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              value={selectedClients}
              options={clients}
              onChange={handleClientSelect}
              getOptionLabel={option => option.clientName}
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} name={option.clientName} {...optionProps}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.clientName}
                  </li>
                );
              }}
              style={{ width: '100%' }}
              renderInput={params => (
                <TextField {...params} label="Checkboxes" placeholder="Clients" />
              )}
            />

          </Form.Group>

          <Form.Group className="mb-ClientName" controlId="exampleForm.ClientName" style={{ margin: '1vw 0' }}>
            {/* title */}
            <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
              {/* <Form.Label style={{ fontSize: '1.3vw', display: 'flex', fontWeight: '600', marginBottom:'1.5vw' }}>Select Client</Form.Label> */}
              {/* <Form.Label style={{ fontSize: '1vw', fontWeight: '600', marginBottom:'1vw', marginLeft: '0.2vw' }}>Select Client</Form.Label> */}
              <p style={{ fontSize: '0.85vw', textAlign: 'left', marginBottom: '1vw', marginLeft: '0.5vw', color: 'rgb(0, 15, 30, 0.7)' }}>Document Types</p>
            </div>

            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              value={selectedDocTypes}
              options={docTypes}
              onChange={handleDocTypeSelect}
              getOptionLabel={option => option.document_type}
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} name={option.document_type} {...optionProps}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.document_type}
                  </li>
                );
              }}
              style={{ width: '100%' }}
              renderInput={params => (
                <TextField {...params} label="Checkboxes" placeholder="Document Type" />
              )}
            />

          </Form.Group>

          <Button
            onClick={() => {
              onClose(); setSelectedClients([]); setSelectedDocTypes([]);
              setPeriod('all');
              filterDataHandler({ reset: true });
            }}
            variant="outlined"
            style={{
              display: 'block',
              borderColor: 'rgb(255, 255, 255, 1)',
              color: 'red',
              padding: '0.3vw 0.5vw',
              border: 'none',
              backgroundColor: 'rgb(255, 255, 255, 0)',
              borderRadius: '0.5vw', textTransform: 'none', fontSize: '0.85vw', fontWeight: 500, letterSpacing: '0.08vw', marginTop: '0vw', marginBottom: '2vw', marginLeft: 'auto', marginRight: 'auto',
            }}
          >
            {' '}
            Remove Filters
            {' '}
          </Button>

          <div style={{ textAlign: 'right', height: '8vh', flexDirection: 'row', alignItems: 'center', display: 'flex', marginTop: '2vw' }}>
            <div style={{ flex: 1 }}>
              <Button
                onClick={() => { onClose(); filterDataHandler(fromDate, toDate, selectedClients.map(client => client.clientId), selectedDocTypes.map(doc => doc.document_type), period); }}
                style={{
                  borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                  width: '100%', marginTop: '1vw' }}
                variant="primary"
                disabled={isSubmitting}
              >
                Show Results
              </Button>
              <Button
                onClick={onHide}
                variant="outlined"
                style={{ display: 'block',
                  borderColor: 'rgb(255, 255, 255, 1)', color: '#1c6c6c', padding: '0.3vw 0.5vw', border: 'none', backgroundColor: 'rgb(255, 255, 255, 0)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '0.85vw', fontWeight: 500, letterSpacing: '0.08vw',
                  marginTop: '0vw', marginBottom: '4vw', marginLeft: 'auto', marginRight: 'auto' }}
              >
                Cancel
              </Button>
            </div>
          </div>

        </Form>

      </Modal.Body>
    </Modal>
  );
};

